module.exports = __webpack_public_path__ + "img/guide-step4-img.81c9a01c.png";